<div class="modal-header">
    <h4 class="modal-title">Angiv dato for denne postering</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <div class="table__viewport">
        <section class="d-flex align-items-center">
            <div class="me-2">
                <app-date-picker-dk class="w-100" [(ngModel)]="selectedDate"></app-date-picker-dk>
            </div>
            <button type="button" class="btn btn-sm btn-primary me-2" (click)="changeEntry()">OK</button>
            <button type="button" class="btn btn-sm btn-primary" (click)="onDismiss()">Annuller</button>
        </section>
    </div>
</div>
